import React from 'react';

/**
 * Inline page loading state (matches PageShell `.page-loading`).
 * Use inside `.page-shell` or full viewport contexts.
 */
function PageLoading({ message, className = '', minHeight = true }) {
  return (
    <div
      className={`page-loading${className ? ` ${className}` : ''}`}
      style={minHeight ? undefined : { minHeight: 'auto' }}
    >
      <div className="page-loading__spinner" aria-hidden />
      {message != null && message !== '' && <p>{message}</p>}
    </div>
  );
}

export default PageLoading;
